module.exports = __webpack_public_path__ + "img/hr-puberty-decal-16.9411a46f.png";